import React, { useContext, useState, useEffect } from 'react';
import classes from './GlobalBanner.module.scss';
import Notification from '@/utils/api/odas/notification';
import { languageContext } from '@/context/language.context';
import { LocationContext } from '@/context/location.context';

const GlobalBanner = (props) => {
  const { currentLanguage: locale } = useContext(languageContext);
  const { region } = useContext(LocationContext);
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    Notification.getGlobalAlerts({ locale: locale, region: region }).then((resp) => {
      if (resp?.data?.alert) {
        setAlertMessage(resp?.data?.alert);
      }
    });
  }, []);

  return (
    <>
      {alertMessage !== '' && (
        <div className={classes.bannerAlert}>
          <div className={classes.bar}>
            <span
              dangerouslySetInnerHTML={{
                __html: alertMessage
              }}
            ></span>
          </div>
        </div>
      )}
    </>
  );
};

GlobalBanner.propTypes = {};

export default GlobalBanner;
